import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import i18n from '../../i18n';

import Tooltip from '../widget/Tooltip';

export default class StarRating extends React.Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        rating: PropTypes.number,
        setRating: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            rating: props.rating || 0
        };
        this.inputRef = React.createRef();
        this.ratingRef = React.createRef();
        this.updateRating = this.updateRating.bind(this);
    }

    componentDidMount() {
        this.inputRef.current.oninvalid = function (e) {
            e.target.setCustomValidity('');
            if (!e.target.validity.valid) {
                e.target.setCustomValidity(i18n.t('rating:invalid_rating'));
            }
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            rating: nextProps.rating || this.state.rating
        });
    }

    getValue() {
        return this.state.rating;
    }

    updateRating(e) {
        const rating = $(this.ratingRef.current).find('.star').index(e.target) + 1;
        this.setState(
            {
                rating
            },
            () => {
                if (this.isValid()) {
                    $(this.ratingRef.current).closest('.form-group').removeClass('has-error');
                    this.inputRef.current.dispatchEvent(new CustomEvent('input', { bubbles: true }));
                } else {
                    $(this.ratingRef.current).closest('.form-group').addClass('has-error');
                }
            }
        );
        this.props.setRating(rating);
    }

    isValid() {
        return !this.inputRef.current.checkValidity() || this.inputRef.current.checkValidity();
    }

    render() {
        return (
            <div className="star-rating" ref={this.ratingRef}>
                <input
                    type="number"
                    name={this.props.name}
                    value={this.state.rating}
                    min={1}
                    max={5}
                    ref={this.inputRef}
                    readOnly={true}
                />
                <Tooltip placement="bottom" title={i18n.t('rating:tooltip_1')}>
                    <i
                        className={classNames('star', { active: this.state.rating >= 1 })}
                        onClick={this.updateRating}
                        onTouchStart={this.updateRating}
                        aria-hidden="true"
                    />
                </Tooltip>
                <Tooltip placement="bottom" title={i18n.t('rating:tooltip_2')}>
                    <i
                        className={classNames('star', { active: this.state.rating >= 2 })}
                        onClick={this.updateRating}
                        onTouchStart={this.updateRating}
                        aria-hidden="true"
                    />
                </Tooltip>
                <Tooltip placement="bottom" title={i18n.t('rating:tooltip_3')}>
                    <i
                        className={classNames('star', { active: this.state.rating >= 3 })}
                        onClick={this.updateRating}
                        onTouchStart={this.updateRating}
                        aria-hidden="true"
                    />
                </Tooltip>
                <Tooltip placement="bottom" title={i18n.t('rating:tooltip_4')}>
                    <i
                        className={classNames('star', { active: this.state.rating >= 4 })}
                        onClick={this.updateRating}
                        onTouchStart={this.updateRating}
                        aria-hidden="true"
                    />
                </Tooltip>
                <Tooltip placement="bottom" title={i18n.t('rating:tooltip_5')}>
                    <i
                        className={classNames('star', { active: this.state.rating >= 5 })}
                        onClick={this.updateRating}
                        onTouchStart={this.updateRating}
                        aria-hidden="true"
                    />
                </Tooltip>
            </div>
        );
    }
}
